import { render, staticRenderFns } from "./SwapConfirmation.vue?vue&type=template&id=338c84ac&"
import script from "./SwapConfirmation.vue?vue&type=script&lang=js&"
export * from "./SwapConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports